interface IProps {
    title: string;
}

const AccountSettingsPageTitle = ({ title }: IProps) => {
    return (
        <h1 className={'text-2xl md:text-3xl font-semibold'}>{title}</h1>
    );
};

export default AccountSettingsPageTitle;